<div class="dialog">
  <div class="dialog__header">
    <div class="dialog__header-left">
      @if (iconName()) {
        <div class="dialog__icon-container">
          <i class="dialog__icon pi" [ngClass]="'pi-' + iconName()"></i>
        </div>
      }

      <div>
        <h2 class="dialog__title">{{ title() }}</h2>
        <span class="dialog__subtitle">{{ subtitle() }}</span>
      </div>
    </div>
    <div class="dialog__header-right">
      <i
        uiCloseDialog
        class="dialog__icon dialog__icon--clickable pi pi-times"></i>
    </div>
  </div>

  <ng-content select="[additional-header]"></ng-content>
</div>
